/* DON'T EDIT THIS FILE: edit original and run build again */ import { Roles } from "../../framework/permission/schema.ts";
import { PermissionCollection } from "../../framework/permission/types.ts";
import {
  canExportOrderRouting,
  canViewCreatedOrderRoutingExport,
  canViewOrderRoutingExport,
  canViewTenantOrderRoutingExport,
} from "./permissions.ts";

const canExportOrderRoutingRoles = [
  Roles.admin,
  Roles.tenantAdmin,
  Roles.sales,
  Roles.salesManager,
  Roles.producer,
  Roles.headOfProducers,
  Roles.backOffice,
  Roles.trader,
  Roles.endClientUser,
];

const ordersExportPermissions: PermissionCollection = {
  namespace: "orders",
  permissions: [
    {
      name: canExportOrderRouting,
      description:
        "Puede exportar las órdenes/pre-órdenes de los listings a CSV",
      roles: canExportOrderRoutingRoles,
    },
    {
      name: canViewOrderRoutingExport,
      description: "Puede ver exportaciones de órdenes/pre-órdenes",
      roles: canExportOrderRoutingRoles,
    },
    {
      name: canViewTenantOrderRoutingExport,
      description:
        "Puede ver cualquier exportación de órdenes/pre-órdenes del tenant",
      roles: [Roles.admin, Roles.tenantAdmin, Roles.backOffice],
    },
    {
      name: canViewCreatedOrderRoutingExport,
      description:
        "Puede ver las exportaciones de órdenes/pre-órdenes creadas por el usuario",
      roles: canExportOrderRoutingRoles,
    },
  ],
};

export default ordersExportPermissions;
